export default function MatchingPage() {
  return (
    <div className="max-w-screen-2xl">
      <h1 className="text-xl mb-2">Employer-Matching Gifts for St. Jude</h1>
      <p>Did you know, thousands of companies match their employees&apos; donations to St. Jude?</p>
      <p>
        You can now request have your donation matched and employer-matching gift be credited to the
        Tiltify campaign!
      </p>
      <br />
      <p>
        <strong>Step 1:</strong> Make a personal donation to the Tiltify campaign
      </p>
      <br />
      <p>
        <strong>Step 2:</strong> On the donation summary screen, click “Search employers” to see if
        your employer has a matching gift program. If so, you&apos;ll find details specific to your
        company&apos;s program.
      </p>
      <br />
      <p>
        <strong>Step 3:</strong> After selecting your employer, you will receive an email with
        instructions on how to submit your matching gift request. After submitting your request and
        clicking the green button in your email, the matching gift will be credited to the campaign
        total within 24 hours.
      </p>
      <br />
      <p className="text-sm">
        <strong>Note:</strong> Employer-matching gifts count towards the campaign total but are not
        eligible for donation rewards offered.
      </p>
      <br />
      <p>
        <strong>Additional talking points to encourage matching gift requests:</strong>
      </p>
      <ul className="list-disc ml-4 mt-1">
        <li className="mb-1">
          Thousands of companies match their employers&apos; donations from big box stores to tech
          companies, international companies and even local employers to your area
        </li>
        <li className="mb-1">
          Each year $4-7B corporate match dollars go unclaimed by employees. Don&apos;t let your
          gift go unmatched
        </li>
        <li className="mb-1">
          Don&apos;t miss out, 65% of Fortune 500 companies match their employees&apos; donations,
          yours may be one of them
        </li>
        <li className="mb-1">
          Employer matching gifts can vary based on the company giving, for example Microsoft
          matches 1:1, Johnson and Johnson 2:1 and Exxon 3:1
        </li>
      </ul>
      <h1 className="text-xl mt-4 mb-2">Donor-Advised Fund Gifts for St. Jude</h1>
      <p>
        You may now use your donor-advised fund to support St. Jude credit your gift to the Tiltify
        campaign!
      </p>
      <br />
      <p>
        <strong>Step 1:</strong> Recommend a gift by contacting your fund administrator, using your
        fund administrator app, or by granting online.
      </p>
      <br />
      <p>
        <strong>Step 2:</strong> Request a donor-advised fund distribution to St. Jude from your
        financial institution. Save the confirmation page for your requested distribution.
      </p>
      <br />
      <p>
        <strong>Step 3:</strong> Then visit{" "}
        <a href="https://www.stjude.org/TiltifyCredit">stjude.org/TiltifyCredit</a> to fill out the
        form to credit your requested distribution to this Tiltify campaign.
      </p>
      <br />
      <p className="text-sm">
        <strong>Note:</strong> DAF gifts count towards the campaign total but are not eligible for
        donation rewards offered.
      </p>
      <p className="text-lg mt-2 mb-2">
        <span>
          Visit{" "}
          <a className="link" href="https://www.stjude.org/TiltifyCredit">
            stjude.org/TiltifyCredit
          </a>{" "}
          for more information & FAQs
        </span>
      </p>
      <h1 className="text-xl mt-4 mb-2">Amplify</h1>
      <p>Do you have the drive to fundraise, just not the time?</p>
      <p>Do you want to support the campaign and see the impact you’ve made?</p>
      <p>Now you can by creating an amplify link to support our campaign!</p>
      <br />
      <p>
        <strong>Step 1: </strong> On a Tiltify campaign, click “Generate amplify link” located under
        the green donate button
      </p>
      <br />
      <p>
        <strong>Step 2: </strong> Input your email and click “Submit” to generate a custom amplify
        link
      </p>
      <br />
      <p>
        <strong>Step 3: </strong> Share to via social, email and/or text to drive donations to our
        campaign and track donations to your link in your Tiltify Dashboard!
      </p>
      <h1 className="text-xl mt-4 mb-2">Donation Match Challenges</h1>
      <p>Are you planning to donate $500 or more?</p>
      <p>Why not inspire a train of donations by issuing a donation match challenge!</p>
      <p>
        You can now match donations up to the total of your match challenge for a defined period of
        time through Tiltify.
      </p>
      <br />
      <p>
        <strong>Step 1: </strong> When donating, click “Create a matching donation” on the right
        side of the donation details page
      </p>
      <br />
      <p>
        <strong>Step 2: </strong> Fill out your personal information then select your donation
        challenge amount ($500+) and (1hr to 5 days)
      </p>
      <br />
      <p>
        <strong>Step 3: </strong> Once live, donors will see matches applied to their donations on
        the campaign page until the match total is met or time expires! Once the challenge is
        complete, the matching donor&apos;s donation will appear on the campaign page.
      </p>
      <br />
      <p className="text-sm">
        <strong>Notes:</strong> Challenges can only be started by Verified donor accounts. If
        multiple challenges are issued at one time, matches stack – meaning donations can be matched
        3x, 5x, etc. until the challenges expire.
      </p>
    </div>
  );
}
